import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import { getGoogleMapsKey } from "../../pages/constants";
import L from "leaflet";

const customIcon = new L.Icon({
  iconUrl:
    "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|abcdef&chf=a,s,ee00FFFF",
  iconSize: [45, 45],
  iconAnchor: [5, 30],
});

export default function MapTest(props) {
  const LocationFinderDummy = () => {
    const map = useMapEvents({
      click(e) {
        console.log(e.latlng);
      },
    });
    return null;
  };

  return (
    <MapContainer
      center={[props.latitude, props.longitude]}
      zoom={15}
      scrollWheelZoom={false}
      style={{ height: "100vh", width: "100wh" }}
      onClick={(coordinate) =>
        console.log("in onClick, coordinate:", coordinate)
      }
    >
      <LocationFinderDummy />
      <ReactLeafletGoogleLayer apiKey={getGoogleMapsKey()} type={"terrain"} />
      {props.markers.map((marker) => {
        return (
          <Marker
            position={[marker.latitude, marker.longitude]}
            title={marker.title}
            icon={customIcon}
          >
            <Popup>{marker.details}</Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
}
